export const USDT = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
      fill="#26A17B"
    />
    <path
      d="M17.7054 17.4765V17.4739C17.5948 17.4816 17.0238 17.5151 15.753 17.5151C14.7369 17.5151 14.0244 17.4868 13.7723 17.4739V17.4765C9.86491 17.3041 6.95044 16.625 6.95044 15.8096C6.95044 14.9967 9.86748 14.3151 13.7723 14.1427V16.8C14.027 16.818 14.7601 16.8617 15.771 16.8617C16.9852 16.8617 17.5922 16.8103 17.7054 16.8V14.1453C21.6051 14.3202 24.5119 14.9993 24.5119 15.8122C24.5119 16.625 21.6025 17.3041 17.7054 17.4791V17.4765ZM17.7054 13.8701V11.4932H23.1459V7.86877H8.33436V11.4932H13.7749V13.8701C9.35301 14.0733 6.02954 14.9479 6.02954 15.9974C6.02954 17.0469 9.35559 17.9215 13.7749 18.1273V25.7466H17.708V18.1273C22.1221 17.9241 25.4405 17.0495 25.4405 16C25.4405 14.953 22.1221 14.0758 17.708 13.8726"
      fill="white"
    />
  </svg>
);
